const itemJson = document.querySelector('.item-json')
const itemXml = document.querySelector('.item-xml')
const itemYml = document.querySelector('.item-yml')

const lineJson = document.querySelector('.export__switching--line-json')
const lineXml = document.querySelector('.export__switching--line-xml')
const lineYml = document.querySelector('.export__switching--line-yml')

function switchToJson() {
	itemJson.style.display = 'block'

	itemXml.style.display = 'none'
	itemYml.style.display = 'none'

	lineJson.style.display = 'block'
	lineXml.style.display = 'none'
	lineYml.style.display = 'none'
}

function switchToXml() {
	itemJson.style.display = 'none'
	itemXml.style.display = 'block'
	itemYml.style.display = 'none'

	lineJson.style.display = 'none'
	lineXml.style.display = 'block'
	lineYml.style.display = 'none'
}

function switchToYml() {
	itemJson.style.display = 'none'
	itemXml.style.display = 'none'
	itemYml.style.display = 'block'

	lineJson.style.display = 'none'
	lineXml.style.display = 'none'
	lineYml.style.display = 'block'
}
